import { create } from 'zustand'

import { MY_WORK_DEFAULT_LIMIT } from './constants'

export type MyWorkTab = 'inProgress' | 'completed'

interface MyWorkState {
  activeTab: MyWorkTab
  searchText: string
  page: number
  limit: number
  sort: string
}

interface MyWorkActions {
  setActiveTab: (tab: MyWorkTab) => void
  setSearchText: (text: string) => void
  setPage: (page: number) => void
  setLimit: (limit: number) => void
  setSort: (sort: string) => void
  reset: () => void
}

const initialState: MyWorkState = {
  activeTab: 'inProgress',
  searchText: '',
  page: 0,
  limit: MY_WORK_DEFAULT_LIMIT,
  sort: '',
}

export const useMyWorkStore = create<MyWorkState & MyWorkActions>((set) => ({
  ...initialState,

  setActiveTab: (tab) => set({ activeTab: tab, page: 0 }),

  setSearchText: (text) => set({ searchText: text }),

  setPage: (page) => set({ page }),

  setLimit: (limit) => set({ limit }),

  setSort: (sort) => set({ sort }),

  reset: () => set(initialState),
}))
